import React from "react";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import UseDataSheet from "./UseDataSheet";

const Sheet = () => {
  const { sheetRef, data } = UseDataSheet();

  const handleExport = () => {
    const { headers = [], structuredData = [] } = data;

    const aoa = [headers];

    structuredData.forEach((row) => {
      const rowValues = headers.map((header) => {
        const cell = row[header];
        if (!cell) return "";

        let value = cell.value;

        // 🔹 Gestion des dates (format dd/mm/yyyy)
        if (cell.type === "date" && value && typeof value === "string" && value.includes("/")) {
          const [day, month, year] = value.split("/").map(Number);
          if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            return new Date(year, month - 1, day);
          }
        }

        // 🔹 Gestion des fichiers
        if (cell.type === "file" && value) {
          try {
            const files = JSON.parse(value);
            if (Array.isArray(files)) {
              return files.map((f) => f.name).join(", ");
            }
          } catch {
            return value;
          }
        }

        // 🔹 Gestion des tableaux (["Français", "Anglais"])
        if (typeof value === "string" && value.trim().startsWith("[") && value.trim().endsWith("]")) {
          try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
              return parsed.join(", ");
            }
          } catch {
            return value;
          }
        }

        return value || "";
      });

      aoa.push(rowValues);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(aoa);

    // 🔹 Appliquer format de cellule pour les dates
    Object.keys(worksheet).forEach((key) => {
      if (key[0] !== "!") {
        const cell = worksheet[key];
        if (cell.v instanceof Date) {
          cell.t = "d";
          cell.z = "yyyy-mm-dd"; // ✅ Format lisible par Excel
        }
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Feuille1");
    XLSX.writeFile(workbook, "Reponse.xlsx");
  };

  return (
    <div>
      <div
        style={{
          marginTop: "10px",
          textAlign: "right",
          marginRight: "10px",
          marginBottom: "10px",
        }}
        className="toolbar-wrapper"
      >
        <button
          onClick={handleExport}
          style={{
            padding: "10px 20px",
            border: "none",
            background: "#43CE0C",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          <DownloadOutlined style={{ marginRight: "10px" }} />
          Télécharger le fichier
        </button>
      </div>

      <div
        className="datasheetClass"
        ref={sheetRef}
        style={{ height: "100vh", width: "100vw" }}
      />
    </div>
  );
};

export default Sheet;
